export interface Category {
  id: string;
  name: string;
  description: string;
  emoji: string;
  color: {
    bg: string;
    bgDark: string;
    text: string;
    textDark: string;
  };
}

// Curated categories - fewer but more substantial
export const CATEGORIES: Category[] = [
  {
    id: 'most-liked',
    name: 'Most Liked',
    description: 'Fan favorites and most popular stories',
    emoji: '❤️',
    color: {
      bg: 'rgba(239, 68, 68, 0.1)',
      bgDark: 'rgba(239, 68, 68, 0.15)',
      text: '#EF4444',
      textDark: '#F87171'
    }
  },
  {
    id: 'forbidden',
    name: 'Forbidden',
    description: 'Affairs, strangers, and taboo encounters',
    emoji: '🔥',
    color: {
      bg: 'rgba(219, 39, 119, 0.1)',
      bgDark: 'rgba(219, 39, 119, 0.15)',
      text: '#DB2777',
      textDark: '#F472B6'
    }
  },
  {
    id: 'intense',
    name: 'Intense',
    description: 'Power play, rough, and passionate',
    emoji: '⚡',
    color: {
      bg: 'rgba(234, 88, 12, 0.1)',
      bgDark: 'rgba(234, 88, 12, 0.15)',
      text: '#EA580C',
      textDark: '#FB923C'
    }
  },
  {
    id: 'romantic',
    name: 'Romantic',
    description: 'Slow burn, emotional, and intimate',
    emoji: '💕',
    color: {
      bg: 'rgba(236, 72, 153, 0.1)',
      bgDark: 'rgba(236, 72, 153, 0.15)',
      text: '#EC4899',
      textDark: '#F9A8D4'
    }
  },
  {
    id: 'queer',
    name: 'Queer',
    description: 'LGBTQ+ stories and experiences',
    emoji: '🏳️‍🌈',
    color: {
      bg: 'rgba(168, 85, 247, 0.1)',
      bgDark: 'rgba(168, 85, 247, 0.15)',
      text: '#A855F7',
      textDark: '#C084FC'
    }
  },
  {
    id: 'adventurous',
    name: 'Adventurous',
    description: 'Public, exhibitionism, and risky',
    emoji: '🌟',
    color: {
      bg: 'rgba(16, 185, 129, 0.1)',
      bgDark: 'rgba(16, 185, 129, 0.15)',
      text: '#10B981',
      textDark: '#34D399'
    }
  }
];

// Static list of most liked story IDs (manually curated)
export const MOST_LIKED_STORY_IDS = [
  'lisbon-neighbor',
  'lyon-bookshop',
  'vienna-divorce',
  'late-summer-in-paris',
  'amsterdam-domme',
  'tokyo-rope-studio',
  'prague-photographer',
  'berlin-backstage',
];

// Helper function to get category by ID
export const getCategoryById = (id: string): Category | undefined => {
  return CATEGORIES.find(cat => cat.id === id);
};
